import React from 'react';
import LoadingPanel from '../../components/Loading/Loading';

const RedirectPage = () => {
  return <LoadingPanel dataUI="redirect-component-loader" />;
};

export default RedirectPage;
